'use strict';

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import Select from 'Components/Forms/Elements/Select';
import Image from 'Pure/Image';
import Link from 'Pure/Link';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import { URL, action } from 'Shared/Routes';
const scope_options = [{
  value: "all",
  label: "Toutes les actualités"
}, {
  value: "local",
  label: "Local"
}, {
  value: "national",
  label: "National"
}];
export default class NewsBlock extends Component {
  state = {
    loading: false,
    scope: 'all',
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchNews({});
  }
  fetchNews = ({
    searched
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllNews'), {
      limit: 3,
      skip: 0,
      scope: 'all',
      front: true,
      searched: searched !== undefined ? searched || undefined : state.searched || undefined,
      order: 'desc',
      order_by: 'date'
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        news: response.data || []
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [name]: value
    });
    component.fetchNews({
      searched: value
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state?.news?.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: "u-margin-top-30"
      });
    } else {
      let modifiers = [];
      if (props.type === 'all') {
        modifiers.push('all-news');
      }
      const news = (state.news || []).map(function (news) {
        let output = /*#__PURE__*/React.createElement("div", {
          className: bemit('c-card', modifiers),
          key: news.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "c-card__img-container"
        }, /*#__PURE__*/React.createElement(Image, {
          className: "c-card__img",
          src: variant({
            img: news.images[0],
            size: 900,
            ratio: '16:9'
          }),
          alt: news.title
        })), /*#__PURE__*/React.createElement("div", {
          className: "c-card__content"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "c-card__title"
        }, news.title), /*#__PURE__*/React.createElement("div", {
          className: news.scope === "local" ? "c-news__scope" : "c-news__scope c-news__scope--dark"
        }, news.scope === "local" ? news?._etablishment?.address?.city : undefined, news?._etablishment?.address?.city ? ' - ' : '', moment(news.date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
          className: "c-card__link-container"
        }, /*#__PURE__*/React.createElement(Button, {
          className: bemit('c-flat-btn', ['front', 'blue', 'spaces-types-block']),
          href: '/actualites/' + news.url,
          component: Link
        }, "En savoir plus"))));
        return output;
      });
      let output = /*#__PURE__*/React.createElement("section", {
        className: "o-news-block " + bemit('o-section', modifiers)
      }, props.type !== 'all' ? /*#__PURE__*/React.createElement("div", {
        className: "o-news-block__top"
      }, /*#__PURE__*/React.createElement("header", {
        className: "o-section__header"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "c-title"
      }, "Actualit\xE9s"))) : /*#__PURE__*/React.createElement("div", {
        className: "o-news-block__top"
      }, /*#__PURE__*/React.createElement("header", {
        className: "o-section__header o-section__header--news"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "c-title"
      }, "Toutes les actualit\xE9s myWO"), /*#__PURE__*/React.createElement("div", {
        className: "c-filters__element"
      }, /*#__PURE__*/React.createElement(Select, {
        onChange: component.handleSearchChange,
        value: state['scope'],
        name: "scope",
        label: "P\xE9rim\xE8tre",
        status: state.status_messages,
        options: scope_options
      })))), /*#__PURE__*/React.createElement("div", {
        className: "o-section__grid o-news-block__list"
      }, news), props.type !== 'all' ? /*#__PURE__*/React.createElement("div", {
        className: "o-news-block__link"
      }, /*#__PURE__*/React.createElement(Button, {
        className: bemit('c-flat-btn', ['front', 'blue', 'spaces-types-block']),
        component: Link,
        href: URL('AllNewsPage')
      }, "Toutes les actualit\xE9s")) : undefined);
      return output;
    }
  }
}
